module.exports = __webpack_public_path__ + "static/media/Kaiwei_Wang_Resume.d3675387.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/intro/src/Kaiwei_Wang_Resume.pdf
// module id = 368
// module chunks = 0